export enum AuthErrorKind {
  Cancelled = 'cancelled',
  WrongCombination = 'wrong-combination',
  EmailTaken = 'email-taken',
  WeakPassword = 'weak-password',
  InvalidEmail = 'invalid-email',
  // An expired or already-used email / purchase link.
  InvalidLink = 'invalid-link',
  TooManyRequests = 'too-many-requests',
  Network = 'network',
  AccountDisabled = 'account-disabled',
  DifferentSignInMethod = 'different-sign-in-method',
  Unknown = 'unknown',
}

// Where a form shows a failure: next to the field it is about, or once for the whole form.
export enum AuthErrorField {
  Email = 'email',
  Password = 'password',
  Form = 'form',
}

export enum AuthFlow {
  SignIn = 'sign-in',
  SignUp = 'sign-up',
  GoogleSignIn = 'google-sign-in',
  AppleSignIn = 'apple-sign-in',
  DesktopSignIn = 'desktop-sign-in',
  CompleteSignup = 'complete-signup',
  VerifyEmail = 'verify-email',
  ResendVerificationEmail = 'resend-verification-email',
  ForgotPassword = 'forgot-password',
  ResetLinkLookup = 'reset-link-lookup',
  ResetPassword = 'reset-password',
  Reauthenticate = 'reauthenticate',
  ChangePassword = 'change-password',
  PasswordChangeNotice = 'password-change-notice',
  ChangeEmail = 'change-email',
  ConfirmEmailChange = 'confirm-email-change',
  RevertEmailChange = 'revert-email-change',
  // Handing the signed-in account to an AI app's OAuth sign-in (the MCP Login URI).
  McpConnect = 'mcp-connect',
}

// A form outcome thrown as an Error so it can carry the reported failure as `cause`.
export class AuthFlowError<Kind extends string = AuthErrorKind> extends Error {
  constructor(
    public readonly kind: Kind,
    options?: ErrorOptions,
  ) {
    super(`Auth flow failed: ${kind}`, options);
    this.name = 'AuthFlowError';
  }
}
